import { message } from 'antd';
import axios from 'axios';
import firebase from 'firebase/app';
import AppConfig from '../config/config';
import { Config } from '../models/config';

const api = axios.create({
  baseURL: AppConfig.apiUrl,
  timeout: AppConfig.timeout,
});

export default class ConfigService {
  static getAll = async function (): Promise<Config> {
    try {
      const response = await api.get('/get_configs');
      return response.data;
    } catch (e) {
      return { maintenance: 'true' } as Config;
    }
  };

  static batchUpdate = async function (body: { key: string; value: any }[]): Promise<Config> {
    try {
      const response = await api.post('/update_configs', body, { headers: { authorization: `Bearer ${await firebase.auth().currentUser?.getIdToken()}` } });
      return response.data;
    } catch (e) {
      if (e?.response?.status == 400) message.warn('請稍後再試');
      throw e;
    }
  };
}
